module.exports = __webpack_public_path__ + "img/bmb-logo.b14ac5f7.png";